import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import * as Constants from '../Shared/Constants.js'
import CommentsList from '../Shared/CommentsList/CommentsList.js'
import TaskManager from '../TaskManager/TaskManager.js';
import { EventEmitter } from "events";
import EntityAssociation from "../Shared/EntityAssociation.js";
import '../Shared/Style.css';
import Attachments from "../Shared/Attachments.js";
import { useDropzone } from 'react-dropzone';
import "./App.css";
import ProductUDIs from "./ProductUDIs.js"

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HC_map from "highcharts/modules/map";
import worldMap from "@highcharts/map-collection/custom/world.geo.json";
import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import CountryRegistrations from '../CountryRegistrations/CountryRegistrations.js';
import GenericDataTable from "../Shared/DataTable/GenericDataTable.js";
import * as LayoutComponents from '../Shared/LayoutComponents.js'

// Added imports for the Change Assessments DataTable
import DataTable from '../Shared/DataTable/DataTable.js';
import RelationProductsComplianceStandards from '../RelationProductsComplianceStandards/RelationProductsComplianceStandards.js';
import RelationProductsComplianceRegulations from '../RelationProductsComplianceRegulations/RelationProductsComplianceRegulations.js';

// register map
Highcharts.maps["custom/world"] = worldMap;

HC_map(Highcharts);
Exporting(Highcharts);
OfflineExporting(Highcharts);


const ItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;
    // Direct link to a tab, e.g. ?productTab=udis&udiTab=eu&udiVersionId=12 from the UDIs page (used on first open only)
    const linkedTabs = useRef(null);
    if (linkedTabs.current === null) {
        const params = new URLSearchParams(window.location.search);
        linkedTabs.current = { productTab: params.get("productTab"), udiTab: params.get("udiTab"), udiVersionId: params.get("udiVersionId") };
    }
    const [initialUdiTab, setInitialUdiTab] = useState(null);
    const [initialUdiVersionId, setInitialUdiVersionId] = useState(null);
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [visibleDetailsTab, setVisibleDetailsTab] = useState("information");
    const [autoCallOverviewFunction, setAutoCallOverviewFunction] = useState(false);
    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(AppContext.isPaneOpen);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [componentKey, setComponentKey] = useState(0);
    const [showItemContextMenu, setShowItemContextMenu] = useState(false);
    const [selectedPDFTab, setSelectedPDFTab] = useState("main");
    const [requestingTranslation, setRequestingTranslation] = useState(false);
    const [requestedTranslation, setRequestedTranslation] = useState(false);
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [showDeleteFileConfirmation, setShowDeleteFileConfirmation] = useState(false);
    const [isDeletingFile, setIsDeletingFile] = useState(false);
    const [currentLegalManufacturer, setCurrentLegalManufacturer] = useState("");
    const [selectedPDFVersion, setSelectedPDFVersion] = useState(null);
    const [isVersionDropdownOpen, setIsVersionDropdownOpen] = React.useState(false);
    const [productFamilies, setProductFamilies] = useState([]);
    const [productCountries, setProductCountries] = useState([]);
    const [legalManufacturers, setLegalManufacturers] = useState([]);
    const [physicalManufacturers, setPhysicalManufacturers] = useState([]);
    const [sppp, setSPPP] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isChangingArchiveStatus, setIsChangingArchiveStatus] = useState(false);
    const [version, setVersion] = useState(0);

    const [isEditingField, setIsEditingField] = useState({
        SKUProductCode: false,
        ProductName: false,
        FamilyName: false,
    });

    const [errorCurrentItem, setErrorCurrentItem] = useState(false);
    const [hasUDIUnsavedChanges, setHasUDIUnsavedChanges] = useState(false);
    const [hasProductUnsavedChanges, setHasProductUnsavedChanges] = useState(false);

    const [isShowingUDIUnsavedChangesWarning, setIsShowingUDIUnsavedChangesWarning] = useState(false);
    const [isShowingProductUnsavedChangesWarning, setIsShowingProductUnsavedChangesWarning] = useState(false);

    AppContext.hasUDIUnsavedChanges = hasUDIUnsavedChanges;
    AppContext.setHasUDIUnsavedChanges = setHasUDIUnsavedChanges;
    AppContext.isShowingUDIUnsavedChangesWarning = isShowingUDIUnsavedChangesWarning;
    AppContext.setIsShowingUDIUnsavedChangesWarning = setIsShowingUDIUnsavedChangesWarning;

    AppContext.hasProductUnsavedChanges = hasProductUnsavedChanges;
    AppContext.setHasProductUnsavedChanges = setHasProductUnsavedChanges;
    AppContext.isShowingProductUnsavedChangesWarning = isShowingProductUnsavedChangesWarning;
    AppContext.setIsShowingProductUnsavedChangesWarning = setIsShowingProductUnsavedChangesWarning;

    const contextMenuButton = useRef(null);
    const contextMenu = useRef(null);
    const versionsMenuButton = useRef(null);
    const versionsMenuOptions = useRef(null);
    const currentItemSKUProductCodeRef = useRef(null);
    const currentItemProductNameRef = useRef(null);

    const isNullOrEmpty = (val) => {
        return val === "" || val === null;
    }

    const hasValue = (val) => {
        return val !== "" && val !== null;
    }

    function stringifyIfObject(value) {
        if (typeof value === "object" && value !== null) {
            return JSON.stringify(value);
        }
        return value;
    }

    const validFormField = (title, field) => {
        if (field == "SKUProductCode") {
            if (isNullOrEmpty(AppContext.currentItem[field])) {
                setErrorCurrentItem(title + " is a mandatory field"); return false;
            }
        }
        if (field == "ProductName") {
            if (isNullOrEmpty(AppContext.currentItem[field])) {
                setErrorCurrentItem(title + " is a mandatory field"); return false;
            }
        }
        return true;
    }

    const saveCurrentItem = () => {
        // Validations
        let isValidForm = true;

        setErrorCurrentItem(false);

        if (!validFormField("Product Code", "SKUProductCode")) isValidForm = false;
        if (!validFormField("Product Name", "ProductName")) isValidForm = false;

        if (!isValidForm) return false;

        setIsSavingItem(true);
        setIsShowingSaveMessage(false);
        AppContext.disableAllItemFormFieldsEdit();

        // Update item remotely and if successful...
        let currentItem = JSON.parse(JSON.stringify(AppContext.currentItem));

        currentItem.Entities = AppContext.linkedObjectsList;

        let updateItemURL = AppContext.dataUrl;

        const formData = new FormData();

        const appendToFormData = (formData, data, parentKey = "") => {
            // 0. Handle File / Blob FIRST (critical)
            if (data instanceof File || data instanceof Blob) {
                formData.append(parentKey, data);
                return;
            }

            // 1. Handle arrays (INCLUDING empty arrays)
            if (Array.isArray(data)) {
                if (data.length === 0) {
                    // IMPORTANT: preserve empty array explicitly
                    formData.append(parentKey, JSON.stringify([]));
                    return;
                }

                data.forEach((item, index) => {
                    appendToFormData(formData, item, `${parentKey}[${index}]`);
                });

                return;
            }

            // 2. Handle objects
            if (typeof data === "object" && data !== null) {
                Object.keys(data).forEach((key) => {
                    const fullKey = parentKey ? `${parentKey}.${key}` : key;
                    appendToFormData(formData, data[key], fullKey);
                });
                return;
            }

            // 3. Primitive values (including null/undefined safety)
            formData.append(parentKey, data ?? "");
        };

        appendToFormData(formData, AppContext.currentItem);

        let requestOptions = {
            method: "PUT",
            body: formData
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);

                    // Update current item
                    AppContext.setCurrentItem(result);

                    // Update local original item to use when cancelling edit
                    AppContext.setOriginalItem(result);

                    setIsShowingSaveMessage(true);

                    setIsEditMode(false);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItem(false);
            });
    };

    const loadProductFamilies = () => {

        let familiesUrl = "/umbraco/api/RIMSProducts/Families";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(familiesUrl, requestOptions)
            .then((response) => {
                checkResponseError(response);
                return response.json();
            })
            .then((result) => {
                if (result) {
                    result.sort((a, b) => a.Name.localeCompare(b.Name));
                    setProductFamilies(result);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });
    };

    const loadCountries = () => {

        let countriesUrl = "/umbraco/api/RIMSProducts/Countries";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(countriesUrl, requestOptions)
            .then((response) => {
                checkResponseError(response);
                return response.json();
            })
            .then((result) => {
                if (result) {
                    result.sort((a, b) => a.CountryName.localeCompare(b.CountryName));
                    setProductCountries(result);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });
    };

    const loadLegalManufacturers = () => {
        let legalManufacturerRoleId = 1;
        return loadOperators(legalManufacturerRoleId, setLegalManufacturers);
    };

    const loadPhysicalManufacturers = () => {
        let physicalManufacturerRoleId = 5;
        return loadOperators(physicalManufacturerRoleId, setPhysicalManufacturers);
    };

    const loadSPPP = () => {
        let systemProcedurePackProducerRoleId = 9;
        return loadOperators(systemProcedurePackProducerRoleId, setSPPP);
    };

    const loadOperators = (roleId, setFunction) => {

        let countriesUrl = "/umbraco/api/RIMSProducts/Operators?roleId=" + roleId;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        return fetch(countriesUrl, requestOptions)
            .then((response) => {
                checkResponseError(response);
                return response.json();
            })
            .then((result) => {
                if (result) setFunction(result);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });

    }

    const checkResponseError = (response) => {
        if (!response.ok) {
            if (response.status === 401)
                document.dispatchEvent(new Event("api:unauthorized"));

            throw new Error("Network response was not ok");
        }
    }

    // On parent change of the details pane status "restart" the popup
    useEffect(() => {

        if (AppContext.isPaneOpen == true) {
            // Immediately activate popup, but wait a bit to trigger the open animation
            setItemDetailsPaneActive(true);
            setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
        }
        else {
            // Immediately do the hide effect but wait 300 to deactivate the popup
            setItemDetailsPaneOpenEffect(false);
            setTimeout(() => { setItemDetailsPaneActive(false); }, 300);
        }

    }, [AppContext.isPaneOpen]);

    const reinitialize = () => {
        const linked = linkedTabs.current;
        linkedTabs.current = {};
        if (linked.productTab || linked.udiTab || linked.udiVersionId) {
            const url = new URL(window.location);
            url.searchParams.delete("productTab");
            url.searchParams.delete("udiTab");
            url.searchParams.delete("udiVersionId");
            window.history.replaceState({}, "", url);
        }

        changeTab(linked.productTab ?? "information");
        setInitialUdiTab(linked.udiTab);
        setInitialUdiVersionId(linked.udiVersionId);
        setAutoCallOverviewFunction(false);
        setSelectedPDFTab("main");
        setIsUploadingFile(false);
        setIsDeletingFile(false);
        setIsSavingItem(false);
        AppContext.setIsShowingDeleteConfirmation(false);

        loadProductFamilies();
        loadCountries();
        loadLegalManufacturers();
        loadPhysicalManufacturers();
        loadSPPP();

        setIsShowingSaveMessage(false);
        setIsEditMode(false);
    }

    useEffect(() => {
        if (itemDetailsPaneActive)
            reinitialize();
    }, [itemDetailsPaneActive]);

    useEffect(() => {
        if (!itemDetailsPaneOpenEffect)
            setShowItemContextMenu(false);
    }, [itemDetailsPaneOpenEffect])


    const openContextualMenu = () => {
        setShowItemContextMenu(!showItemContextMenu);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (contextMenuButton.current && contextMenuButton.current.contains(e.target) ||
                contextMenu.current && contextMenu.current.contains(e.target) ||
                versionsMenuButton.current && versionsMenuButton.current.contains(e.target) ||
                versionsMenuOptions.current && versionsMenuOptions.current.contains(e.target)
            )
                return;

            setIsVersionDropdownOpen(false);
            setShowItemContextMenu(false);
            AppContext.setIsShowingDeleteConfirmation(false);

        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    /*
        When in the view/edit pane, when you click a field this will set edit mode on for that field
    */
    const enableTaskFormFieldEdit = (field, e) => {
        e.stopPropagation();
        let newObj = { ...isEditingField, [field]: true };
        setIsEditingField(newObj);
    };

    /*
        Disable all editable fields in the view/edit form
    */
    const disableAllItemFormFieldsEdit = () => {
        let newObj = { ...isEditingField };
        for (let prop in newObj) {
            newObj[prop] = false;
        }
        setIsEditingField(newObj);
    };

    const onDrop = useCallback((acceptedFiles) => {

        const formData = new FormData();
        acceptedFiles.forEach(file => formData.append('files', file));

        let requestOptions = {
            method: 'POST',
            body: formData,
        };

        setIsUploadingFile(true);

        let attachmentUrl = "/Umbraco/Api/Compliance/Upload/?complianceType=" + AppContext.ComplianceType + "&uniqueId=" + AppContext.currentItem.UniqueId;

        fetch(attachmentUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data) {
                    // Update item
                    AppContext.setCurrentItem({ ...AppContext.currentItem, MedboardResourceId: data });

                    // Update list
                    AppContext.setData(list =>
                        list.map(item =>
                            item.Id == AppContext.currentItem.Id ? { ...item, MedboardResourceId: data } : item
                        )
                    );

                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsUploadingFile(false);
            });

    }, [AppContext.currentItem]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': [], // PDF
        },
        multiple: false,
    });


    // Canceling edit changes
    const cancelEdit = () => {
        AppContext.setCurrentItem(AppContext.originalItem);
        setIsEditMode(false);
        setVersion(v => v + 1);
    }

    const changeArchiveStatus = (status) => {

        let url = AppContext.productsArchiveUrl + AppContext.currentItem.Id + "&archive=" + status;

        let requestOptions = {
            method: "PATCH",
        };

        setIsChangingArchiveStatus(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((data) => {

                let updatedItem = { ...AppContext.currentItem, Archived: status };

                // Update item
                AppContext.setCurrentItem(updatedItem);

                // Update original item
                AppContext.setOriginalItem(updatedItem);

                // Update list
                const isActiveFilter = AppContext.selectedFilterProductsArchive === "false";
                const isArchivedFilter = AppContext.selectedFilterProductsArchive === "true";

                const shouldRemove =
                    (isActiveFilter && status === true) ||
                    (isArchivedFilter && status === false);

                if (shouldRemove) {
                    AppContext.setData(list =>
                        list.filter(item => item.Id !== updatedItem.Id)
                    );
                } else {
                    AppContext.setData(list => [
                        updatedItem,
                        ...list.filter(item => item.Id !== updatedItem.Id)
                    ]);
                }

            })
            .catch((error) => {
            })
            .finally(() => {
                setIsChangingArchiveStatus(false);
            });

    }

    const toggleEditMode = () => {
        setIsEditMode(!isEditMode);
        setIsShowingSaveMessage(false);
    }

    const changeTab = (tab) => {

        if (hasUDIUnsavedChanges) {
            setIsShowingUDIUnsavedChangesWarning(true);
            return;
        }

        if (hasProductUnsavedChanges) {
            setIsShowingProductUnsavedChangesWarning(true);
            return;
        }

        setIsShowingSaveMessage(false);
        setVisibleDetailsTab(tab);
    }


    const closePane = () => {

        if (hasUDIUnsavedChanges) {
            setIsShowingUDIUnsavedChangesWarning(true);
            return;
        }

        if (hasProductUnsavedChanges) {
            setIsShowingProductUnsavedChangesWarning(true);
            return;
        }

        AppContext.closePane();
    }


    const deepEqual = (a, b) => {
        if (a === b) return true;

        if (
            typeof a !== "object" || a === null ||
            typeof b !== "object" || b === null
        ) {
            return false;
        }

        const keysA = Object.keys(a);
        const keysB = Object.keys(b);

        if (keysA.length !== keysB.length) return false;

        for (let key of keysA) {
            if (!keysB.includes(key)) return false;
            if (!deepEqual(a[key], b[key])) return false;
        }

        return true;
    };


    // Avoid losing unsaved changes
    useEffect(() => {
        if (!deepEqual(AppContext.currentItem, AppContext.originalItem))
            AppContext.setHasProductUnsavedChanges(true);
        else
            AppContext.setHasProductUnsavedChanges(false);

    }, [AppContext.currentItem, AppContext.originalItem]);


    const tabs = [
        { title: "Product Details", tab: "information" },
        { title: "UDIs", tab: "udis" },
        { title: "Configurations", tab: "configurations" },
        { title: "Standards", tab: "standards" },
        { title: "Regulations", tab: "regdocs" },
        { title: "Literature", tab: "literature" },
        { title: "Tasks", tab: "tasks" },
        { title: "Comments", tab: "comments" },
        { title: "Change Assessments", tab: "changeAssessments" },
    ];


    const displayFieldOnly = true;
    let fullWidthPane = true;

    return (
        <>

            {itemDetailsPaneActive ?

                <div
                    style={{ height: "100vh", overflow: "auto", backgroundColor: "#f7fafc" }}
                    className={`${fullWidthPane ? "slide-pane-full-width" : "slide-pane"} ${itemDetailsPaneOpenEffect ? "open" : ""}`}
                >
                    <div className="content">


                        <p style={{ color: "#555", fontSize: "11px" }}>
                            <span className="breadcrumb-link" style={{ marginRight: "5px" }} onClick={() => closePane()}>Products</span>
                            {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? null :
                                <>
                                    &gt; <span style={{ marginLeft: "5px" }}> {AppContext.currentItem.ProductName}</span>
                                </>
                            }
                        </p>


                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}

                        <div className="item-details-content">

                            <div className="item-details-content-tabs">

                                <div className="nav" style={{ display: "flex", flexDirection: "column", gap: "4px" }} >

                                    {tabs.map((tab, index) => {
                                        if (tab.onlyAdmin && AppContext.userRole !== "Admin") {
                                            return null;
                                        }

                                        return (
                                            <a
                                                key={index} // better than index if tab.tab is unique
                                                onClick={() => changeTab(tab.tab)}
                                                className={`nav-item item-details-menu-tab ${visibleDetailsTab === tab.tab ? "active" : ""
                                                    }`}
                                            >
                                                {tab.title}
                                            </a>
                                        );
                                    })}

                                </div>

                            </div>

                            <div className="item-details-content-content">

                                {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                                    <>
                                        <LayoutComponents.PageLoading />
                                    </>
                                ) : (
                                    <>

                                        {/* Header */}
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                                <h2 style={{ margin: 0, fontSize: "24px", fontWeight: 700, color: "#1a202c", display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <i className="fas fa-box-open" style={{ color: "#2b6cb0" }} />
                                                    Product Details
                                                </h2>

                                                <span style={{ fontSize: "16px", color: "#4a5568", fontWeight: 600, background: "#edf2f7", padding: "4px 12px", borderRadius: "6px" }}>
                                                    {AppContext.currentItem?.SKUProductCode}&nbsp;&nbsp;•&nbsp;&nbsp;{AppContext.currentItem?.ProductName}
                                                </span>

                                                {visibleDetailsTab == "information" ? <>
                                                    {AppContext.currentItem.Archived ?
                                                        <span id="archiveTag" className="u-label g-bg-gray-dark-v4 g-rounded-3 g-ml-30">Archived</span>
                                                        : null}
                                                    {AppContext.userRole === "Admin" ? (
                                                        <a
                                                            href={`/your-medboard/country-registrations/registrations/?defaultOpenAddItemPopup=true&filter[ProductId]=${AppContext.currentItem?.Id || ''}`}
                                                            className="action-button add-task-button no-hover-color registration-link"
                                                        >
                                                            <i className="fas fa-plus-circle g-mr-5"></i>
                                                            Add registration
                                                        </a>
                                                    ) : (
                                                        <button
                                                            disabled
                                                            className="action-button add-task-button disabled-button"
                                                            title="No permission. Check with your Admin." style={{ backgroundColor: "#c0c0c0" }}
                                                        >
                                                            <i className="fas fa-plus-circle g-mr-5"></i>
                                                            Add registration
                                                        </button>
                                                    )}
                                                </> : null}

                                            </div>

                                            <div style={{ display: "flex", gap: "8px" }}>


                                                {visibleDetailsTab == "information" ? <>

                                                    {AppContext.userRole == "Admin" ? <>

                                                        {isEditMode ?

                                                            <div id="buttom-bar" >

                                                                {/* FORMS BUTTONS */}

                                                                <div className="action-button-bar" style={{ marginTop: "0px" }}>

                                                                    <div className="action-button-bar-left"></div>
                                                                    <div className="action-button-bar-center"></div>

                                                                    <div className="action-button-bar-right">

                                                                        {!isSavingItem ? (
                                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "right", gap: "8px" }}>
                                                                                <button
                                                                                    className="action-button save-button"
                                                                                    onClick={() => cancelEdit()}
                                                                                    onMouseOver={(e) => {
                                                                                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                                                                                        e.currentTarget.style.borderColor = "#c1c4c8";
                                                                                    }}
                                                                                    onMouseOut={(e) => {
                                                                                        e.currentTarget.style.backgroundColor = "#ffffff";
                                                                                        e.currentTarget.style.borderColor = "#dee2e6";
                                                                                    }}
                                                                                    style={{
                                                                                        display: "inline-flex",
                                                                                        alignItems: "center",
                                                                                        padding: "6px 14px",
                                                                                        cursor: "pointer",
                                                                                        transition: "all 0.2s ease-in-out",
                                                                                        color: "#5f6368",
                                                                                        border: "1px solid #dee2e6",
                                                                                        backgroundColor: "#ffffff",
                                                                                        whiteSpace: "nowrap",
                                                                                        outline: "none"
                                                                                    }}
                                                                                >
                                                                                    Cancel
                                                                                </button>
                                                                                <button
                                                                                    className="action-button save-button"
                                                                                    onClick={saveCurrentItem}
                                                                                >
                                                                                    Save
                                                                                </button>
                                                                            </div>
                                                                        ) : (
                                                                            <>
                                                                                <LoadingSpinnerImage />
                                                                            </>
                                                                        )}


                                                                    </div>


                                                                </div>

                                                            </div>

                                                            :

                                                            <>
                                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>




                                                                    {isChangingArchiveStatus ? <span style={{ marginRight: "30px" }}><LoadingSpinnerImage /></span> :
                                                                        <button
                                                                            className="action-button save-button"
                                                                            onClick={() => changeArchiveStatus(!AppContext.currentItem.Archived)}
                                                                            onMouseOver={(e) => {
                                                                                e.currentTarget.style.backgroundColor = "#f8f9fa";
                                                                                e.currentTarget.style.borderColor = "#c1c4c8";
                                                                            }}
                                                                            onMouseOut={(e) => {
                                                                                e.currentTarget.style.backgroundColor = "#ffffff";
                                                                                e.currentTarget.style.borderColor = "#999";
                                                                            }}
                                                                            style={{
                                                                                display: "inline-flex",
                                                                                alignItems: "center",
                                                                                padding: "6px 14px",
                                                                                marginRight: "30px",
                                                                                fontSize: "13px",
                                                                                fontWeight: "500",
                                                                                cursor: "pointer",
                                                                                transition: "all 0.2s ease-in-out",
                                                                                color: "#3c4043",
                                                                                border: "1px solid #999",
                                                                                backgroundColor: "#ffffff",
                                                                                whiteSpace: "nowrap",
                                                                                outline: "none",
                                                                                height: "31px",
                                                                                marginLeft: "10px"
                                                                            }}
                                                                        >
                                                                            <i
                                                                                className={AppContext.currentItem.Archived ? "fas fa-box-open" : "fas fa-archive"}
                                                                                style={{ marginRight: "6px", fontSize: "12px" }}
                                                                            ></i>
                                                                            {AppContext.currentItem.Archived ? "Unarchive" : "Archive"}
                                                                        </button>
                                                                    }


                                                                    {isShowingSaveMessage ?
                                                                        <div style={{
                                                                            flex: 1,
                                                                            justifyContent: "right",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            marginRight: "20px",
                                                                        }}>
                                                                            <span className="save-message-shown">
                                                                                Save successful!
                                                                            </span>
                                                                        </div>
                                                                        : null}

                                                                    <div>
                                                                        <div className="view-task-field" style={{
                                                                            textAlign: "right",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            marginBottom: "0px",
                                                                            marginRight: "10px"
                                                                        }}>
                                                                            <span onClick={() => toggleEditMode()} value="EDIT" style={{ borderRadius: "20px" }} className="edit-rims-edit-button">
                                                                                <i className="far fa-edit pointer g-mr-8"></i>Edit Product
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                            </>
                                                        }

                                                    </>

                                                        : null}

                                                </> : null}

                                                <button ref={contextMenuButton} onClick={openContextualMenu} style={{ border: "1px solid #cbd5e0", background: "white", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", color: "#4a5568" }}>
                                                    <i className="fas fa-ellipsis-v" />
                                                </button>

                                                <button onClick={() => closePane()} style={{ border: "1px solid #cbd5e0", background: "white", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", color: "#4a5568" }}>
                                                    <i className="fas fa-times" />
                                                </button>
                                            </div>
                                        </div>


                                        {/* Main content */}


                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>


                                            {/* INFORMATION DASHBOARD */}

                                            {visibleDetailsTab == "information" ? <>

                                                {/* LEFT */}

                                                <div style={{ flex: 1, minWidth: "400px", display: "flex", flexDirection: "column", gap: "24px" }}>



                                                    <LayoutComponents.InfoBlock>
                                                        <div style={{ display: "flex", gap: "40px" }}>


                                                            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>

                                                                <div style={{ width: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>

                                                                    <FieldTypes.ItemDetailsField_Image AppContext={AppContext} fieldName={"File"} urlFieldName={"Image"} fieldTitle={"Product Image"} fieldRemoveStatus={"DeleteImage"} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />

                                                                </div>

                                                                <div style={{ width: "50%", marginLeft: "40px" }}>
                                                                    <div style={{ marginBottom: "20px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Product Code
                                                                        </span>
                                                                        <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                            <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"SKUProductCode"} fieldTitle={"Product Code"} mandatory={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        </span>
                                                                    </div>

                                                                    <div style={{ marginBottom: "20px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Product Name
                                                                        </span>
                                                                        <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                            <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"ProductName"} fieldTitle={"Product Name"} mandatory={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        </span>
                                                                    </div>

                                                                    <div style={{ marginBottom: "20px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Product Family
                                                                        </span>
                                                                        <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                            <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"FamilyId"} fieldName={"FamilyName"} fieldTitle={"Product Family"} LOV={productFamilies} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={false} addEmptyIfNotMandatory={true} defaultEmptyId="0" defaultEmptyText="N/A" link={"/your-medboard/country-registrations/product-portfolio/product-portfolio-filter/?mode=4&filter=[PARAM]"} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                            </div>




                                                        </div>
                                                    </LayoutComponents.InfoBlock>


                                                    <LayoutComponents.InfoBlock>


                                                        <div style={{ display: "flex", gap: "40px" }}>


                                                            <div>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                    UDI-DI i.e. GTIN
                                                                </span>

                                                                <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                    <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"UDIDI"} fieldTitle={"UDI-DI i.e. GTIN"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                </span>
                                                            </div>



                                                            <div style={{ borderLeft: "1px solid #e2e8f0", paddingLeft: "40px" }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                    Country Of Origin
                                                                </span>

                                                                <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>

                                                                    {isEditMode ? <>
                                                                        <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"CountryOfOrigin"} fieldName={"CountryOf"} fieldTitle={"Country Of Origin"} LOV={productCountries} LOVIdField={"CountryId"} LOVNameField={"CountryName"} mandatory={false} addEmptyIfNotMandatory={true} defaultEmptyId="0" defaultEmptyText="N/A" enableSearch={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />

                                                                    </> : <>
                                                                        {AppContext.currentItem?.CountryOf ?
                                                                            <>
                                                                                <img
                                                                                    className="countryFlag"
                                                                                    src={AppContext.currentItem?.CountryOfFlagLink}
                                                                                    style={{ height: "20px", marginRight: "5px" }}
                                                                                    alt=""
                                                                                />
                                                                                {AppContext.currentItem?.CountryOf}
                                                                            </>
                                                                            : "---"}
                                                                    </>}

                                                                </span>
                                                            </div>




                                                            <div style={{ borderLeft: "1px solid #e2e8f0", paddingLeft: "40px" }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                    Made In
                                                                </span>

                                                                <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>


                                                                    {isEditMode ? <>
                                                                        <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"MadeIn"} fieldName={"MadeInCountry"} fieldTitle={"Made In"} LOV={productCountries} LOVIdField={"CountryId"} LOVNameField={"CountryName"} mandatory={false} addEmptyIfNotMandatory={true} defaultEmptyId="0" defaultEmptyText="N/A" enableSearch={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />

                                                                    </> : <>
                                                                        {AppContext.currentItem?.MadeInCountry ?
                                                                            <>
                                                                                <img
                                                                                    className="countryFlag"
                                                                                    src={AppContext.currentItem?.MadeInCountryFlagLink}
                                                                                    style={{ height: "20px", marginRight: "5px" }}
                                                                                    alt=""
                                                                                />
                                                                                {AppContext.currentItem?.MadeInCountry}
                                                                            </>
                                                                            : "---"}
                                                                    </>}

                                                                </span>
                                                            </div>

                                                        </div>



                                                    </LayoutComponents.InfoBlock>





                                                    <LayoutComponents.InfoBlock>
                                                        <h4 style={{ margin: "0 0 20px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096", borderBottom: "1px solid #edf2f7", paddingBottom: "10px" }}>
                                                            Authorized Supply Chain / Operators
                                                        </h4>

                                                        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

                                                            {/* Entry Node: Distributor */}
                                                            <div style={{ paddingLeft: "14px", borderLeft: "4px solid #3398dc" }}>
                                                                <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                    Legal Manufacturers
                                                                </label>
                                                                <FieldTypes.ItemDetailsField_MultiSelect key={`lm_${version}`} AppContext={AppContext} fieldTitle={"Legal Manufacturers"} fieldName={"LegalManufacturersIds"} selectedItems={AppContext.currentItem.LegalManufacturersIds} LOV={legalManufacturers} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} itemLink={"/your-medboard/country-registrations/certificates/view-operator/[PARAM]/"} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} allowAddOperator={true} operatorRoleId={1} onRefreshOperators={loadLegalManufacturers} />
                                                            </div>

                                                            {/* Entry Node: Representative */}
                                                            <div style={{ paddingLeft: "14px", borderLeft: "4px solid #2a6e92" }}>
                                                                <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                    Physical Manufacturers
                                                                </label>
                                                                <FieldTypes.ItemDetailsField_MultiSelect key={`pm_${version}`} AppContext={AppContext} fieldTitle={"Physical Manufacturers"} fieldName={"PhysicalManufacturerIds"} selectedItems={AppContext.currentItem.PhysicalManufacturerIds} LOV={physicalManufacturers} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} itemLink={"/your-medboard/country-registrations/certificates/view-operator/[PARAM]/"} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} allowAddOperator={true} operatorRoleId={5} onRefreshOperators={loadPhysicalManufacturers} />
                                                            </div>

                                                            {/* Entry Node: Importer */}
                                                            <div style={{ paddingLeft: "14px", borderLeft: "4px solid #203864" }}>
                                                                <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                    SPPP
                                                                </label>
                                                                <FieldTypes.ItemDetailsField_MultiSelect key={`sppp_${version}`} AppContext={AppContext} fieldTitle={"SPPP"} fieldName={"SPPsIds"} selectedItems={AppContext.currentItem.SPPsIds} LOV={sppp} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} itemLink={"/your-medboard/products/?filter[SPPPs]=[PARAM]"} allowAddOperator={true} operatorRoleId={9} onRefreshOperators={loadSPPP} />
                                                            </div>

                                                        </div>

                                                    </LayoutComponents.InfoBlock>







                                                    <LayoutComponents.InfoBlock>
                                                        <h4 style={{ margin: "0 0 16px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096" }}>
                                                            Custom Fields
                                                        </h4>
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                                            {/* CUSTOM USER FIELDS */}
                                                            {/* CUSTOM USER FIELDS */}
                                                            {/* CUSTOM USER FIELDS */}
                                                            {AppContext.enableCustomFields ?
                                                                <FieldTypes.FieldType_CustomUserFieldsView key={`custom_fields_${version}`} globalContext={AppContext} isEditing={isEditMode} />
                                                                : null}
                                                        </div>
                                                    </LayoutComponents.InfoBlock>


                                                </div>





                                                {/* RIGHT */}

                                                <div style={{ flex: 1, minWidth: "280px", display: "flex", flexDirection: "column", gap: "24px" }}>




                                                    <LayoutComponents.InfoBlock>
                                                        <h4 style={{ margin: "0 0 20px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096", borderBottom: "1px solid #edf2f7", paddingBottom: "10px" }}>
                                                            Analytics
                                                        </h4>

                                                        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>

                                                            <div style={{ flex: 1, }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                    Countries Selling
                                                                </span>
                                                                <span style={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 600,
                                                                    color: AppContext.currentItem?.NumberOfRegistrationsFilteredBySelling > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                    display: "block",
                                                                    lineHeight: 1
                                                                }}>
                                                                    <a href={`/your-medboard/country-registrations/registrations/?filter[ProductId]=${AppContext.currentItem?.Id}&filter[Selling]=1`}>{AppContext.currentItem?.NumberOfRegistrationsFilteredBySelling ?? 0}
                                                                    </a>
                                                                </span>
                                                            </div>

                                                            <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "15px" }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                    Registrations
                                                                </span>
                                                                <span style={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 600,
                                                                    color: AppContext.currentItem?.NumberOfRegistrations > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                    display: "block",
                                                                    lineHeight: 1
                                                                }}>
                                                                    <a href={`/your-medboard/country-registrations/registrations/?filter[ProductId]=${AppContext.currentItem?.Id}`}>
                                                                        {AppContext.currentItem?.NumberOfRegistrations ?? 0}
                                                                    </a>

                                                                </span>
                                                            </div>

                                                            <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "15px" }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                    Configurations
                                                                </span>
                                                                <span style={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 600,
                                                                    color: AppContext.currentItem?.NumberOfConfigurations > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                    display: "block",
                                                                    lineHeight: 1
                                                                }}>
                                                                    <span className="pointer" onClick={() => changeTab("configurations")}>{AppContext.currentItem?.NumberOfConfigurations ?? 0}</span>
                                                                </span>
                                                            </div>


                                                            <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "15px" }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                    Open Tasks
                                                                </span>
                                                                <span style={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 600,
                                                                    color: AppContext.currentItem?.TasksCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                    display: "block",
                                                                    lineHeight: 1
                                                                }}>
                                                                    <span className="pointer" onClick={() => changeTab("tasks")}>{AppContext.currentItem?.TasksCount ?? 0}</span>
                                                                </span>
                                                            </div>

                                                            <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "15px" }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                    Comments
                                                                </span>
                                                                <span style={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 600,
                                                                    color: AppContext.currentItem?.NumberOfComments > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                    display: "block",
                                                                    lineHeight: 1
                                                                }}>
                                                                    <span className="pointer" onClick={() => changeTab("comments")}>{AppContext.currentItem?.NumberOfComments ?? 0}</span>
                                                                </span>
                                                            </div>

                                                            <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "15px" }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                    Change Assessments
                                                                </span>
                                                                <span style={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 600,
                                                                    color: AppContext.currentItem?.ChangeAssessments?.length > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                    display: "block",
                                                                    lineHeight: 1
                                                                }}>
                                                                    <span className="pointer" onClick={() => changeTab("changeAssessments")}>{AppContext.currentItem?.ChangeAssessments?.length ?? 0}</span>
                                                                </span>
                                                            </div>


                                                        </div>

                                                    </LayoutComponents.InfoBlock>



                                                    <LayoutComponents.InfoBlock>
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                                                            <ProductRegistrationsMap AppContext={AppContext} />

                                                        </div>
                                                    </LayoutComponents.InfoBlock>


                                                    <LayoutComponents.InfoBlock>
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>

                                                            <h4 style={{ margin: "0 0 20px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096", borderBottom: "1px solid #edf2f7", paddingBottom: "10px" }}>
                                                                Product Registrations Status
                                                            </h4>

                                                            <div style={{ display: "flex", flexDirection: "row", gap: "40px" }}>
                                                                <ProductStatusColumnChart AppContext={AppContext} />
                                                            </div>

                                                        </div>
                                                    </LayoutComponents.InfoBlock>




                                                </div>

                                            </> : null}






                                            {/* COMMENTS */}

                                            {visibleDetailsTab == "comments" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>

                                                    <LayoutComponents.InfoBlock>
                                                        <CommentsList entityType={AppContext.entityType} entityId={AppContext.currentItem.Id} userList={AppContext.users} currentUserId={AppContext.currentUserId} />
                                                    </LayoutComponents.InfoBlock>

                                                </div>

                                            }

                                            {/* CHANGE ASSESSMENTS */}

                                            {visibleDetailsTab == "changeAssessments" && (
                                                <div style={{ height: "100%", overflow: "auto", width: "100%" }}>
                                                        <div style={{ marginBottom: "20px" }}>
                                                        <ProductChangeAssessmentsTable
                                                                AppContext={AppContext}
                                                        />
                                                        </div>
                                                </div>
                                            )}



                                            {/* TASKS */}

                                            {visibleDetailsTab == "tasks" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>
                                                    <LayoutComponents.InfoBlock>

                                                        <TaskManager
                                                            emitter={new EventEmitter()}
                                                            paramEntityType="product-skus"
                                                            paramEntityId={AppContext.currentItem.Id}
                                                            paramCompanyId={AppContext.currentCompanyId}
                                                            paramUserId={AppContext.currentUserId}
                                                            paramIsSlimVersion={true}
                                                            paramExternalLinkedObjects={[{ EntityType: "product-skus", EntityId: AppContext.currentItem.Id }]}
                                                            paramHasLimitedWidth={true} />

                                                    </LayoutComponents.InfoBlock>
                                                </div>
                                            }




                                            {/* LINKED TO */}

                                            {visibleDetailsTab == "linkedto" &&
                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>
                                                    <EntityAssociation context={AppContext} />
                                                </div>
                                            }


                                            {/* ATTACHMENTS */}

                                            {visibleDetailsTab == "attachments" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>
                                                    <LayoutComponents.InfoBlock>
                                                        <Attachments EntityType={AppContext.entityType} EntityId={AppContext.currentItem.Id} users={AppContext.users} userRole={AppContext.userRole} />
                                                    </LayoutComponents.InfoBlock>
                                                </div>
                                            </>}




                                            {/* UDIs */}

                                            {visibleDetailsTab == "udis" && <>

                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>
                                                    <LayoutComponents.InfoBlock>
                                                        <ProductUDIs AppContext={AppContext} initialTab={initialUdiTab} initialVersionId={initialUdiVersionId} />
                                                    </LayoutComponents.InfoBlock>
                                                </div>
                                            </>}




                                            {/* STANDARDS */}

                                            {visibleDetailsTab == "standards" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>
                                                    <ProductStandardsTable AppContext={AppContext} />
                                                </div>
                                            </>}




                                            {/* REGULATORY DOCUMENTS */}

                                            {visibleDetailsTab == "regdocs" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>
                                                    <ProductRegulatoryDocumentsTable AppContext={AppContext} />
                                                </div>
                                            </>}



                                            {/* LITERATURE */}

                                            {visibleDetailsTab == "literature" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>
                                                    <RelatedReviewsTable AppContext={AppContext} />
                                                </div>
                                            </>}



                                            {/* CONFIGURATIONS */}

                                            {visibleDetailsTab == "configurations" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>
                                                    <LayoutComponents.InfoBlock>
                                                        <ConfigurableDevicesList AppContext={AppContext} />
                                                    </LayoutComponents.InfoBlock>
                                                </div>
                                            </>}





                                        </div>







                                    </>
                                )}
                            </div>




                        </div>





                    </div>
                </div>

                : null}








            {showItemContextMenu && (
                <div
                    ref={contextMenu}
                    style={{
                        position: "fixed",
                        top: `50px`,
                        right: `70px`,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "4px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        borderRadius: "15px",

                    }}
                >

                    {/* DELETE */}
                    {AppContext.userRole === "Admin" ? (
                        !AppContext.isShowingDeleteConfirmation ? (
                            <div className="context-menu-option" onClick={() => AppContext.setIsShowingDeleteConfirmation(true)}>
                                <i className="far fa-trash-alt"></i> Delete this item
                            </div>
                        ) : (
                            AppContext.isDeletingItem ? (
                                <LoadingSpinnerImage />
                            ) : (
                                <div className="context-menu-option context-delete-option" onClick={AppContext.deleteCurrentItem}>
                                    <i className="far fa-trash-alt"></i> Confirm delete?
                                </div>
                            )
                        )
                    ) : (
                        <div className="context-menu-option disabled">
                            <i className="far fa-trash-alt"></i> Delete (No Permission)
                        </div>
                    )}


                </div>
            )}







            {/* Unsaved UDI Changes Warning Popup */}
            {/* Unsaved UDI Changes Warning Popup */}

            {AppContext.isShowingProductUnsavedChangesWarning ?

                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000
                    }}
                >
                    <div
                        style={{
                            width: "360px",
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                            padding: "20px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px"
                        }}
                    >
                        {/* Title */}
                        <div style={{ fontSize: "1rem", fontWeight: 600 }}>
                            Unsaved Changes
                        </div>

                        {/* Message */}
                        <div style={{ fontSize: "0.9rem", color: "#555", lineHeight: "1.4" }}>
                            There are unsaved changes in the Product Details screen.
                            <br />
                            Please save or cancel your changes before leaving.
                        </div>

                        {/* Actions */}
                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                            <button
                                onClick={() => AppContext.setIsShowingProductUnsavedChangesWarning(false)}
                                style={{
                                    padding: "8px 16px",
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontSize: "0.85rem",
                                    fontWeight: 500,
                                    transition: "background-color 0.2s ease"
                                }}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#155fa0"}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#1976d2"}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>

                : null}









        </>
    );
};









const ProductStandardsTable = ({ AppContext }) => {

    
    return (
        <div id="standards">
            <div className="product-view-block" style={{ backgroundColor: "white" }}>
                
                <RelationProductsComplianceStandards productId={AppContext.currentItem.Id} showTitleAsSubTitle />

            </div>
        </div>
    );
};





const ProductRegulatoryDocumentsTable = ({ AppContext }) => {

    return (
        
        <div id="regdocs">
            <div className="product-view-block" style={{ backgroundColor: "white" }}>
                
                <RelationProductsComplianceRegulations productId={AppContext.currentItem.Id} showTitleAsSubTitle />

            </div>
        </div>

    );
};





const RelatedReviewsTable = ({ AppContext }) => {

    const [references, setReferences] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    let dataUrl = AppContext?.productsLiteratureUrl + AppContext.currentItem.Id;



    useEffect(() => {

        setIsLoading(true);

        let requestOptions = {
            method: "GET",
        };

        fetch(dataUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                setReferences(result);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoading(false);
            });

    }, []);



    const getOriginType = (origin, type) => {
        let name = "";
        let title = "";
        const textColor = "#757575";
        const bgColor = "#e1e1e1";

        switch (origin) {
            case "product-family":
                name = "Family";
                title = `This ${type} is linked to the family of this product`;
                break;
            case "product-skus":
                name = "Product";
                title = `This ${type} is linked to this product`;
                break;
            default:
                break;
        }

        return (
            <div
                title={title}
                style={{
                    color: textColor,
                    borderRadius: "5px",
                    padding: "5px 8px",
                    backgroundColor: bgColor,
                    width: "100px",
                    textAlign: "center",
                    cursor: "help",
                }}
            >
                {name}
            </div>
        );
    };

    return (
        <div id="relatedreviews">
            <div className="product-view-block" style={{ textAlign: "center", backgroundColor: "white" }}>
                <h3>Literature</h3>
                <br />

                {isLoading ? <div><LoadingSpinnerImage /></div> : <>

                    {references.length === 0 ? (
                        <span>
                            There are no related references associated to this product
                        </span>
                    ) : (
                        <table
                            border="1"
                            className="dataTable"
                            style={{ width: "100%", marginBottom: 0 }}
                        >
                            <thead>
                                <tr style={{ backgroundColor: "#f3f3f3" }}>
                                    <th>TITLE</th>
                                    <th>AUTHORS</th>
                                    <th>SOURCE</th>
                                    <th>YEAR</th>
                                    <th>LINKED TO</th>
                                </tr>
                            </thead>
                            <tbody>
                                {references.map((reference) => (
                                    <tr key={reference.Id} style={{ height: "21px" }}>
                                        <td
                                            style={{
                                                width: "50%",
                                                padding: "5px",
                                                textAlign: "left",
                                            }}
                                        >
                                            <a
                                                href={`${AppContext.productReferenceManagerListItemUrl}?referenceId=${reference.Id}`}
                                            >
                                                {reference.Title}
                                            </a>
                                        </td>
                                        <td style={{ width: "15%", padding: "5px" }}>
                                            {reference.Authors}
                                        </td>
                                        <td style={{ width: "15%", padding: "5px" }}>
                                            {reference.Source}
                                        </td>
                                        <td style={{ width: "10%", padding: "5px" }}>
                                            {reference.Year}
                                        </td>
                                        <td style={{ width: "10%", padding: "5px", textAlign: "left" }}>
                                            {getOriginType(reference.EntityType, "reference")}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                </>}
            </div>
        </div>
    );
};






const ConfigurableDevicesList = ({ AppContext }) => {
    const [devices, setDevices] = useState([]);
    const [originalDevices, setOriginalDevices] = useState([]);
    const [enabled, setEnabled] = useState(false);

    const [isEditing, setIsEditing] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState(null);
    const [saveSuccess, setSaveSuccess] = useState(false);

    const isAdmin = AppContext.userRole === "Admin";

    useEffect(() => {
        setIsLoading(true);

        let url = AppContext.productsConfigurationsUrl + AppContext.currentItem.Id;

        fetch(url, { method: "GET" })
            .then((response) => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then((result) => {
                if (result) {
                    setDevices(result.ConfigurableDevices);
                    setOriginalDevices(result.ConfigurableDevices);
                    setEnabled(result.ConfigurableDevice);
                }
            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const updateDevices = (newDevices) => {
        setDevices(newDevices);
    };

    // TOGGLE STILL SAVES IMMEDIATELY
    const toggleEnabled = (value) => {
        setEnabled(value);
        save(true, value);
    };

    const handleAddRow = () => {
        const newDevice = {
            Id: 0,
            ProductId: AppContext.currentItem.Id,
            Reference: "",
            Description: "",
        };
        updateDevices([...devices, newDevice]);
    };

    const handleDelete = (index) => {
        const updated = devices.filter((_, i) => i !== index);
        updateDevices(updated);
    };

    const handleChange = (index, field, value) => {
        const updated = [...devices];
        updated[index] = { ...updated[index], [field]: value };
        updateDevices(updated);
    };

    const cancel = () => {
        setDevices(originalDevices);
        setIsEditing(false);
    };

    const save = (wasToggle = false, isEnabled = enabled) => {
        let data = {
            ConfigurableDevice: isEnabled,
            ConfigurableDevices: wasToggle ? originalDevices : devices,
        };

        setError(null);
        setIsSaving(true);
        setSaveSuccess(false);

        let url = AppContext.productsConfigurationsUrl + AppContext.currentItem.Id;

        fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        })
            .then((response) => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then((result) => {
                if (result) {
                    setDevices(result.ConfigurableDevices);
                    setOriginalDevices(result.ConfigurableDevices);

                    if (!wasToggle) {
                        setSaveSuccess(true);
                        setIsEditing(false);
                    }
                }
            })
            .catch((error) => {
                console.log("error: " + error);
                setError(error);
            })
            .finally(() => {
                setIsSaving(false);
            });
    };

    return (
        <div>
            <h3>Configurations:</h3>
            <br />

            {isLoading ? (
                <LoadingSpinnerImage />
            ) : (
                <div>
                    {/* ALWAYS VISIBLE TO ADMIN */}
                    {isAdmin && (
                        <label
                            style={{
                                fontSize: "13px",
                                background: "#dcedfe",
                                padding: "4px 17px 4px 10px",
                                borderRadius: "20px",
                            }}
                        >
                            {isSaving ? (
                                <LoadingSpinnerImage small={true} />
                            ) : (
                                <input
                                    type="checkbox"
                                    checked={enabled}
                                    onChange={(e) =>
                                        toggleEnabled(e.target.checked)
                                    }
                                    style={{
                                        width: "30px",
                                        verticalAlign: "middle",
                                    }}
                                />
                            )}
                            Enable Configurations for this Product
                        </label>
                    )}

                    {/* NOTHING BELOW IF DISABLED */}
                    {enabled && (
                        <div style={{ marginTop: "30px" }}>
                            {/* EDIT BUTTON (ONLY WHEN NOT EDITING) */}
                            {isAdmin && !isEditing && (
                                <div style={{ textAlign: "right" }}>

                                    <div className="view-task-field" style={{ textAlign: "right" }} >
                                        <span
                                            onClick={() => { setSaveSuccess(false); setIsEditing(true) }}
                                            value="EDIT"
                                            style={{ borderRadius: "20px" }}
                                            className="edit-rims-edit-button">
                                            <i className="fas fa-edit g-pr-8"></i>Edit</span>
                                    </div>
                                </div>
                            )}

                            {/* ADD BUTTON (EDIT MODE ONLY) */}
                            {isAdmin && isEditing && (
                                <button
                                    type="button"
                                    onClick={handleAddRow}
                                    className="action-button add-task-button g-mb-10 pull-right"
                                >
                                    + Add Configuration
                                </button>
                            )}

                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th style={{ width: "15%" }}>
                                            Reference
                                        </th>
                                        <th style={{ width: "50%" }}>
                                            Description
                                        </th>
                                        {isEditing && (
                                            <th style={{ width: "10%" }}>
                                                Options
                                            </th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {devices.map((device, index) => (
                                        <tr key={index}>
                                            <td>
                                                {isEditing ? (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={
                                                            device.Reference ||
                                                            ""
                                                        }
                                                        onChange={(e) =>
                                                            handleChange(
                                                                index,
                                                                "Reference",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    device.Reference
                                                )}
                                            </td>

                                            <td>
                                                {isEditing ? (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={
                                                            device.Description ||
                                                            ""
                                                        }
                                                        onChange={(e) =>
                                                            handleChange(
                                                                index,
                                                                "Description",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    device.Description
                                                )}
                                            </td>

                                            {isEditing && (
                                                <td
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <i
                                                        className="fas fa-times-circle pointer"
                                                        onClick={() =>
                                                            handleDelete(index)
                                                        }
                                                        title="Delete"
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>



                            {saveSuccess && (
                                <span>Configurations saved!</span>
                            )}


                            {/* SAVE / CANCEL */}
                            {isAdmin && isEditing && (
                                <>
                                    {isSaving ? (
                                        <LoadingSpinnerImage />
                                    ) : (
                                        <div className="form-group">

                                            <button
                                                onClick={cancel}
                                                className="action-button save-button"
                                                style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    padding: "6px 14px",
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out",
                                                    whiteSpace: "nowrap",
                                                    outline: "none",
                                                    color: "#5f6368",
                                                    border: "1px solid #dee2e6",
                                                    backgroundColor: "#ffffff"
                                                }}
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                onClick={() => save(false)}
                                                className="action-button save-button"
                                                style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    padding: "6px 14px",
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out",
                                                    whiteSpace: "nowrap",
                                                    outline: "none",
                                                    color: "#ffffff",
                                                    border: "1px solid #1a73e8",
                                                    backgroundColor: "#1a73e8",
                                                }}
                                            >
                                                Save Configurations
                                            </button>


                                        </div>
                                    )}

                                    {error && <span>Error: {error}</span>}

                                </>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};






const ProductRegistrationsMap = ({ AppContext }) => {
    const [options, setOptions] = useState(null);
    const [loading, setLoading] = useState(true);

    const productId = AppContext?.currentItem?.Id;

    const isProductIdValid = (id) => {
        return id !== null && id !== undefined && String(id).trim() !== "";
    };
    useEffect(() => {
        if (!productId) return;

        const fetchData = async () => {
            try {
                const res = await fetch(
                    `/umbraco/api/ProductRegistrationsApi/RegistrationCountriesStats?establishmentId=&productId=${productId}`
                );

                const data = await res.json();

                const groupedData = data.reduce((acc, item) => {
                    const key = item.countryCode?.trim().toLowerCase();
                    if (!key) return acc;

                    if (!acc[key]) {
                        acc[key] = {
                            "hc-key": key,
                            value: 0,
                            countryName: item.countryName,
                            custom: {
                                countryId: item.countryId,
                                productId: productId,
                                details: []
                            }
                        };
                    } else {
                        if (acc[key].countryName === 'European Union' && item.countryName !== 'European Union') {
                            acc[key].countryName = item.countryName;

                            if (item.countryId) {
                                acc[key].custom.countryId = item.countryId;
                            }
                        }
                    }

                    acc[key].value += Number(item.value) || 0;

                    acc[key].custom.details.push({
                        countryName: item.countryName,
                        value: Number(item.value) || 0
                    });

                    return acc;
                }, {});

                const mapData = Object.values(groupedData);


                setOptions({
                    chart: {
                        map: "custom/world",
                    },

                    title: {
                        text: "Registrations by Country",
                    },

                    legend: {
                        title: {
                            text: "Registrations",
                        },
                    },

                    exporting: {
                        local: true,
                        libURL: "/assets/js/highcharts/libs/",
                    },

                    colorAxis: {
                        min: 0,
                        stops: [
                            [0, "#cce0ff"],
                            [0.5, "#7cb5ec"],
                            [1, "#003399"],
                        ],
                    },

                    mapNavigation: {
                        enabled: true,
                        enableMouseWheelZoom: true,
                    },

                    tooltip: {
                        enabled: true,
                        useHTML: true,
                        formatter: function () {
                            if (!this.point) return "";

                            let pointTitle = this.point.name || this.point.countryName || this.key || 'Region';

                            const customData = this.point.custom;
                            const isSingleDetail = customData.details && customData.details.length === 1;
                            if (isSingleDetail)
                                pointTitle = this.point.countryName || this.point.name || this.key || 'Region';

                            let tooltipHtml = '<span style="font-weight:600; font-size: 11px; padding-bottom:5px;">' + pointTitle + '</span><br/>';
                            if (customData && customData.details && customData.details.length > 0) {
                                customData.details.sort((a, b) => b.value - a.value).forEach(detail => {
                                    const detailName = detail.countryName || '';
                                    const isMatch = detailName.includes(pointTitle) || pointTitle.includes(detailName);
                                    if (isSingleDetail && isMatch) {
                                        tooltipHtml += detail.value + ' registrations<br/>';
                                    } else {
                                        tooltipHtml += detailName + ': ' + detail.value + ' registrations<br/>';
                                    }
                                });
                            } else if (this.point.value !== undefined) {
                                tooltipHtml += 'Total: ' + this.point.value;
                            }

                            return tooltipHtml;
                        }
                    },

                    series: [
                        {
                            data: mapData,
                            name: "Registrations",
                            joinBy: "hc-key",
                            states: {
                                hover: { color: "#a4edba" },
                            },

                            cursor: "pointer",
                            point: {
                                events: {
                                    click: function () {
                                        const customData = this.custom;
                                        if (!customData) return;

                                        let currentCountryId = customData.countryId;
                                        const currentProductId = customData.productId;
                                        const isSingleDetail = customData.details && customData.details.length === 1;

                                        if (isSingleDetail && customData.details[0]?.countryName === 'European Union') {
                                            currentCountryId = 2;
                                        }

                                        let url = `/your-medboard/country-registrations/registrations/?filter[CountryId]=${currentCountryId}`;

                                        if (isProductIdValid(currentProductId)) {
                                            url += `&filter[ProductId]=${encodeURIComponent(currentProductId)}`;
                                        }

                                        window.location.href = url;
                                    },
                                },
                            },
                        },
                    ],

                    credits: {
                        enabled: true,
                        text: "MedBoard",
                        href: "https://www.medboard.com",
                        mapText: null,
                    },
                });

                setLoading(false);
            } catch (err) {
                console.error(err);
                setLoading(false);
            }
        };

        fetchData();
    }, [productId]);

    return (
        <>
            {loading && (
                <div style={{ textAlign: "center" }}>
                    <img
                        src="/assets/js/frontend/public/loading-spinner.gif"
                        alt="loading"
                    />
                </div>
            )}

            {!loading && options && (
                <HighchartsReact
                    highcharts={Highcharts}
                    constructorType="mapChart"
                    options={options}
                />
            )}
        </>
    );
};





const ProductStatusColumnChartOLD = ({ AppContext }) => {
    const [options, setOptions] = useState(null);
    const [loading, setLoading] = useState(true);

    const productId = AppContext?.currentItem?.Id;

    useEffect(() => {
        if (!productId) return;

        const fetchData = async () => {
            try {
                const res = await fetch(
                    `/Umbraco/Api/ProductRegistrationsApi/ProductStatusStats?productId=${productId}`
                );

                const data = await res.json();

                const possibleColors = [
                    { statusId: 0, color: "#3398dc" },
                    { statusId: 1, color: "#72c02c" },
                    { statusId: 2, color: "#e64b3b" },
                    { statusId: 3, color: "#72c02c" },
                    { statusId: 4, color: "#72c02c" },
                    { statusId: 5, color: "#e64b3b" },
                    { statusId: 6, color: "#bbb" },
                    { statusId: 7, color: "#3398dc" },
                    { statusId: 8, color: "#000" },
                    { statusId: 9, color: "#e57d20" },
                ];

                const categories = [];
                const seriesData = [];

                data.forEach((item) => {
                    const colorMatch = possibleColors.find(
                        (c) => c.statusId === item.StatusId
                    );

                    categories.push(item.StatusName);

                    seriesData.push({
                        y: item.Count,
                        color: colorMatch ? colorMatch.color : "gray",
                    });
                });

                setOptions({
                    chart: {
                        type: "column",
                    },

                    title: {
                        text: "Country Registrations Summary",
                    },

                    exporting: {
                        local: true,
                        libURL: "/assets/js/highcharts/libs/",
                    },

                    xAxis: {
                        categories,
                        title: {
                            text: "Status",
                        },
                    },

                    yAxis: {
                        min: 0,
                        title: {
                            text: "Activity",
                        },
                    },

                    legend: {
                        enabled: false,
                    },

                    series: [
                        {
                            name: "Activity",
                            data: seriesData,
                        },
                    ],

                    credits: {
                        enabled: true,
                        text: "MedBoard",
                        href: "https://www.medboard.com",
                    },
                });

                setLoading(false);
            } catch (err) {
                console.error("Error loading chart:", err);
                setLoading(false);
            }
        };

        fetchData();
    }, [productId]);

    return (
        <>
            {loading && (
                <div style={{ textAlign: "center" }}>
                    <img
                        src="/assets/js/frontend/public/loading-spinner.gif"
                        alt="loading"
                    />
                </div>
            )}

            {!loading && options && (
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
            )}
        </>
    );
};





const ProductStatusColumnChart = ({ AppContext }) => {
    const [loading, setLoading] = useState(true);
    const [results, setResults] = useState([]);

    const productId = AppContext?.currentItem?.Id;

    useEffect(() => {
        if (!productId) return;


        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await fetch(
                    `/umbraco/api/ProductRegistrationsApi/ProductStatusStats?productId=${productId}`
                );
                const data = await res.json();

                const possibleColors = [
                    { statusId: 0, color: "#BFDDF3", borderColor: "#5B9BD5", textColor: "#000", backgroundColor: "#f8fafc" }, // blue
                    { statusId: 1, color: "#CFE9B8", borderColor: "#6FAE2D", textColor: "#000", backgroundColor: "#f8fafc" }, // green
                    { statusId: 2, color: "#F6C3BC", borderColor: "#D9534F", textColor: "#000", backgroundColor: "#f8fafc" }, // red
                    { statusId: 3, color: "#CFE9B8", borderColor: "#6FAE2D", textColor: "#000", backgroundColor: "#f8fafc" }, // green
                    { statusId: 4, color: "#CFE9B8", borderColor: "#6FAE2D", textColor: "#000", backgroundColor: "#f8fafc" }, // green
                    { statusId: 5, color: "#F6C3BC", borderColor: "#D9534F", textColor: "#000", backgroundColor: "#f8fafc" }, // red
                    { statusId: 6, color: "#E3E3E3", borderColor: "#9A9A9A", textColor: "#000", backgroundColor: "#f8fafc" }, // gray
                    { statusId: 7, color: "#BFDDF3", borderColor: "#5B9BD5", textColor: "#000", backgroundColor: "#f8fafc" }, // blue
                    { statusId: 8, color: "#D6D6D6", borderColor: "#4A4A4A", textColor: "#000", backgroundColor: "#f8fafc" }, // black/neutral
                    { statusId: 9, color: "#F8D2AF", borderColor: "#D9822B", textColor: "#000", backgroundColor: "#f8fafc" }, // orange
                ];

                let mappedResults = data.map(r => {
                    let pC = possibleColors.find(i => i.statusId == r.StatusId);
                    return {
                        ...r,
                        Color: pC?.color,
                        BorderColor: pC?.borderColor,
                        TextColor: pC?.textColor,
                        BackgroundColor: pC?.backgroundColor,
                    };
                });

                setResults(mappedResults);
            } catch (err) {
                console.error(err);
            }
            setLoading(false);
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <div style={{ textAlign: "center", padding: "20px" }}>
                <img src="/assets/js/frontend/public/loading-spinner.gif" alt="loading" />
            </div>
        );
    }

    return (
        <div style={{ width: "100%" }}>

            {results.map(status => (
                <a
                    key={status.StatusId}
                    href={`/your-medboard/country-registrations/registrations/?filter[Status]=${status.StatusId}&filter[ProductId]=${AppContext.currentItem?.Id}`}
                    className="status-list-item"
                    style={{ backgroundColor: status.BackgroundColor }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span
                            className="status-dot"
                            style={{ backgroundColor: status.BorderColor || "#cbd5e0" }}
                        />
                        <span style={{ fontSize: "13px", fontWeight: 600 }}>
                            {status.StatusName}
                        </span>
                    </div>

                    <strong style={{ fontSize: "15px", color: "#777" }}>
                        {status.Count}
                    </strong>
                </a>
            ))}
        </div>
    );
};

// ==========================================
// NEW CHANGE ASSESSMENTS TABLE COMPONENT
// ==========================================
const ProductChangeAssessmentsTable = ({ AppContext, refresh, customButtons = null }) => {

    const rowStyleProcessor = (row) => {
        const value = row.ExpiryDate;
        if (!value) return "";

        const date = new Date(value);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);

        if (date < today) return "datatable-row-red";

        const daysUntilDue = Math.ceil((date - today) / (1000 * 60 * 60 * 24));
        if (daysUntilDue <= 30) return "datatable-row-yellow";

        return "";
    };

    return (
        <>
            <GenericDataTable
                columns={[
                    {
                        key: "IdCheckbox",
                        label: "",
                        sortable: false,
                        type: "checkbox",
                        size: "25px",
                    },
                    {
                        key: "Id", label: "Assessment", sortable: false, size: "120px",
                        render: ({ value }) => (
                            <div style={{ textAlign: "center", width: "93px" }}>
                                <a
                                    href={`/your-medboard/country-registrations/change-assessments/?changeId=${value}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        backgroundColor: "#f7fafc", padding: "0px 6px", borderRadius: "5px", border: "1px solid #e2e8f0",
                                        color: "#3182ce",
                                        fontWeight: "500"
                                    }}
                                >
                                    Open ↗
                                </a>
                            </div>
                        ),
                    },
                    {
                        key: "Title", label: "Title", sortable: true, size: "300px",
                        render: ({ row, value }) => (
                            <FieldTypes.FieldType_Text value={value} />
                        )
                    },
                    {
                        key: "ChangeAssessmentType", label: "Type", sortable: true, size: "200px",
                        render: ({ value }) => (
                            <FieldTypes.FieldType_ChangeAssessmentType value={value} />
                        ),
                    },
                    {
                        key: "ResponsibleOwner", label: "Responsible", sortable: true, size: "150px",
                        render: ({ value }) => (
                            <FieldTypes.FieldType_User value={value} users={AppContext.users} />
                        ),
                    },
                    {
                        key: "DueDate", label: "Due Date", sortable: true, size: "150px",
                        render: ({ value }) => (
                            <FieldTypes.FieldType_DateWithExpiredWarning value={value} />
                        ),
                    },
                    {
                        key: "Progress", label: "Progress", sortable: true, size: "350px",
                        render: ({ row, value }) => (
                            <FieldTypes.FieldType_ProgressBar value={row} />
                        ),
                    },
                    {
                        key: "ActionRequiredCount", label: "Action Required", sortable: true, size: "350px",
                        render: ({ row, value }) => (
                            <FieldTypes.FieldType_RedProgressBar value={row} />
                        ),
                    },
                    {
                        key: "CertificateCount", label: "Certificates", sortable: true, size: "100px",
                        render: ({ value }) => (
                            <FieldTypes.FieldType_Text value={value} />
                        ),
                    },
                    {
                        key: "CountryCount", label: "Countries", sortable: true, size: "100px",
                        render: ({ value }) => (
                            <FieldTypes.FieldType_Text value={value} />
                        ),
                    },
                    {
                        key: "ProductCount", label: "Products", sortable: true, size: "100px",
                        render: ({ value }) => (
                            <FieldTypes.FieldType_Text value={value} />
                        ),
                    },
                    {
                        key: "CreatedOn", label: "Date Created", sortable: true, size: "150px",
                        render: ({ value }) => (
                            <FieldTypes.FieldType_SimpleDate value={value} />
                        ),
                    }
                ]}
                fetchUrl="/umbraco/api/RIMSRegistrations/ChangeAssessments/"
                enableDelete={AppContext.userRole === "Admin" ? true : false}
                initialSortColumn={"Title"}
                enableExport={true}
                deleteUrl="/umbraco/api/RIMSRegistrations/BulkChangeAssessments/?changeIds="
                exportUrl="/umbraco/api/RIMSRegistrations/ChangeAssessmentsExport/?ids="
                queryParams={{ "filter[products]": AppContext.currentItem.Id }}
                exportFileName={`${AppContext.currentItem.Name}-change-assessments-export.xlsx`}
                rowTitleKey="Title"
                searchPlaceholder="Search Change Assessments"
                LoadingComponent={LoadingSpinnerImage}
                customButtons={customButtons}
                refresh={refresh}
                showTotalCount={true}
                totalCountUrl="/umbraco/api/RIMSRegistrations/ChangeAssessmentsCount/"
                rowStyleProcessor={rowStyleProcessor}
                enableExport={false}
            />
        </>
    );
};

export default ItemDetailsPane;